import ArrowRightSVG from "./ArrowRightSVG";
import ArrowLeftSVG from "./ArrowLeftSVG";
import PlaySVG from "./PlaySVG";
import HomeSVG from "./HomeSVG";
import ReelSVG from "./ReelSVG";
import AiSVG from "./AiSVG";
import DiagramSVG from "./DiagramSVG";
import ComputerGuyAndAntennaSVG from "./ComputerGuyAndAntennaSVG";
import PhoneWithHandSVG from "./PhoneWithHandSVG";
import WorkflowSVG from "./WorkflowSVG";
import ComputerWithCloudSVG from "./ComputerWithCloudSVG";
import BoxWithGearSVG from "./BoxWithGearSVG";
import LifecycleSVG from "./LifecycleSVG";
import MarketplaceSVG from "./MarketplaceSVG";
import DollarSignSVG from "./DollarSignSVG";
import AutonomousManagementSVG from "./AutonomousManagementSVG";
import EyeFocusSVG from "./EyeFocusSVG";
import WarningCircleSVG from "./WarningCircleSVG";
import CircleCheckMarkSVG from "./CircleCheckMarkSVG";
import GearInsideCircleSVG from "./GearInsideCircleSVG";
import ComputerWithSchemeSVG from "./ComputerWithSchemeSVG";
import ComputerFocusingPersonSVG from "./ComputerFocusingPersonSVG";
import GearWithSchemaSVG from "./GearWithSchemaSVG";
import ComputerWithAdjustableWrenchSVG from "./ComputerWithAdjustableWrench";
import GraphWithMagnificationSVG from "./GraphWithMagnificationSVG";
import WorldWithSchemeSVG from "./WorldWithSchemeSVG";
import RobotWithLittleBoxSVG from "./RobotWithLittleBoxSVG";
import CycleInsideCirleSVG from "./CycleInsideCircleSVG";
import GraphDownArrowWithDollarSignSVG from "./GraphDownArrowWithDollarSignSVG";
import ClockSVG from "./ClockSVG";
import MessageSVG from "./MessageSVG";
import BellWithCheckmarkSVG from "./BellWithCheckmarkSVG";
import QuestionBubbleSVG from "./QuestionBubbleSVG";
import DeepDiveSVG from "./DeepDiveSVG";
import HistoricalDataSVG from "./HistoricalDataSVG";
import LikeFingerSVG from "./LikeFingerSVG";
import ProactiveCommunicationSVG from "./ProactiveCommunicationSVG";
import CostReductionSVG from "./CostReductionSVG";
import LeadTimeReductionSVG from "./LeadTimeReductionSVG";
import AutomaticCaseSVG from "./AutomaticCaseSVG";
import ComprehensiveVisibilitySVG from "./ComprehensiveVisibilitySVG";
import WindowAndCommentSVG from "./WindowAndCommentSVG";
import FilterSVG from "./FilterSVG";
import OkSVG from "./OkSVG";
import ComprehensiveFaultVisibilitySVG from "./ComprehensiveFaultVisibilitySVG";
import ServiceSVG from "./ServiceSVG";
import ComputerMarketplaceSVG from "./ComputerMarketplaceSVG";
import GraphArrowUpInsideCircleSVG from "./GraphArrowUpInsideCircleSVG";
import ModularArchitectureSVG from "./ModularArchitectureSVG";
import Signal5GSVG from "./Signal5GSVG";
import ComputerWithMeterSVG from "./ComputerWithMeterSVG";
import CloudWithSchemeSVG from "./CloudWithSchemeSVG";
import WorldAndSchemeLineSVG from "./WorldAndSchemeLineSVG";
import ComputerWithPoliceSVG from "./ComputerWithPoliceSVG";
import PuzzleSvg from "./PuzzleSVG";
import ScreenWithDollarSignAndGearSVG from "./ScreenWithDollarSignAndGearSVG";
import ComputerWithCarSVG from "./ComputerWithCarSVG";
import ComputerWithRocketSVG from "./ComputerWithRocketSVG";
import RobotAndGearSVG from "./RobotAndGearSVG";
import TruckWithBoxAndComputerSVG from "./TruckWithBoxAndComputerSVG";
import ComputerWithChessPieceSVG from "./ComputerWithChessPieceSVG";
import RocketAndHandWithCoinSVG from "./RocketAndHandWithCoinSVG";
import ClockWithChipInsideSVG from "./ClockWithChipInsideSVG";
import BoxWithLockSVG from "./BoxWithLockSVG";
import ChipInsideCircleAndWirelessControlSVG from "./ChipInsideCircleAndWirelessControlSVG";
import ComputerWithMapAndLittleBoxSVG from "./ComputerWithMapAndLittleBoxSVG";
import PersonWithArrowsSVG from "./PersonWithArrowsSVG";
import PersonFocusedWithCheckmarkSVG from "./PersonFocusedWithCheckmarkSVG";
import ComputerWithEyeAndChipSVG from "./ComputerWithEyeAndChipSVG";
import ComputerWithChecklistBehindSVG from "./ComputerWithChecklistBehindSVG";
import PhoneWithBoxesConnectedSVG from "./PhoneWithBoxesConnectedSVG";
import RearAndMachineSVG from "./RearAndMachineSVG";
import WorldAndCheckmarkSVG from "./WorldAndCheckmarkSVG";
import SchieldWithCheckmarkSVG from "./SchieldWithCheckmarkSVG";
import PersonInsideChipSVG from "./PersonInsideChipSVG";
import BoxWithCircleInsideSVG from "./BoxWithCircleInsideSVG";
import BoxAndAdjustableWrenchSVG from "./BoxAndAdjustableWrenchSVG";
import GraphDownArrowWithDollarSign2SVG from "./GraphDownArrowWithDollarSign2SVG";
import NetworkSVG from "./NetworkSVG";
import ArrowsDownSVG from "./ArrowsDownSVG";
import GearInsidePersonSVG from "./GearInsidePersonSVG";
import GraphArrowDownUpDownSVG from "./GraphArrowDownUpDownSVG";
import ArrowsUpSVG from "./ArrowsUpSVG";
import ChipInsideCircleArrowSVG from "./ChipInsideCircleArrowSVG";
import PersonWithLightSVG from "./PersonWithLightSVG";
import ComputerWithSoundBarSVG from "./ComputerWithSoundBarSVG";
import ComputerWithPopUpOverSVG from "./ComputerWithPopUpOverSVG";
import WorldWithRingSVG from "./WorldWithRingSVG";
import BrainSVG from "./BrainSVG";
import GearWithCheckmarkSVG from "./GearWithCheckmarkSVG";
import CheckmarksConnectedByALineSVG from "./CheckmarksConnectedByALineSVG";
import SchemeWithCheckmarkShieldSVG from "./SchemeWithCheckmarkShieldSVG";
import SchemeAndBuildingInlineSVG from "./SchemeAndBuildingInlineSVG";
import InfoSVG from "./InfoSVG";
import CloseSVG from "./CloseSVG";
import CircleSVG from "./CircleSVG";
import ComputerWithLightSVG from "./ComputerWithLightSVG";
import GearsWithArrowsSVG from "./GearsWithArrowsSVG";
import CloudWithMachineSVG from "./CloudWithMachineSVG";
import ChipSVG from "./ChipSVG";
import GearWithCircuitsSVG from "./GearWithCircuitsSVG";
import CirclesConnectedSVG from "./CirclesConnectedSVG";
import WorldWithMachineSVG from "./WorldWithMachineSVG";
import CloudWithCircuitsSVG from "./CloudWithCircuitsSVG";
import GearWithCircuits2SVG from "./GearWithCircuits2SVG";
import CloudLikeSunSVG from "./CloudLikeSunSVG";
import ComputerWithBoxAndPencilsSVG from "./ComputerWithBoxAndPencilsSVG";
import PeopleAndCheckmarkSVG from "./PeopleAndCheckmarkSVG";
import ChipWithCheckmarkSVG from "./ChipWithCheckmarkSVG";
import PeopleWithMessageCloudSVG from "./PeopleWithMessageCloudSVG";
import PeopleConnectedByGearSVG from "./PeopleConnectedByGearSVG";
import GraphWithMagnificationAndGearSVG from "./GraphWithMagnificationAndGearSVG";
import ComputerWithGearAndCircuitsSVG from "./ComputerWithGearAndCircuitsSVG";
import WorldWithCircuitsSVG from "./WorldWithCircuitsSVG";
import ArrowsUpWithDollarSignSVG from "./ArrowsUpWithDollarSignSVG";
import DartboardSVG from "./DartboardSVG";
import ArrowsDownWithPeopleSVG from "./ArrowsDownWithPeopleSVG";
import CustomerServiceSVG from "./CustomerServiceSVG";
import GraphArrowUpSVG from "./GraphArrowUpSVG";
import GraphWithDollarSignSVG from "./GraphWithDollarSignSVG";
import ComputerWithPaperSVG from "./ComputerWithPaperSVG";
import PeopleWithCircuitsInsideCircleSVG from "./PeopleWithCircuitsInsideCircleSVG";
import PeopleInsideGearSVG from "./PeopleInsideGearSVG";
import ComputerWithPersonAndMessageBubbleSVG from "./ComputerWithPersonAndMessageBubbleSVG";
import PeopleWithCheckmarkAndMessageBubbleSVG from "./PeopleWithCheckmarkAndMessageBubbleSVG";
import PlayButtonSVG from "./PlayButtonSVG";
import RewindButtonSVG from "./RewindButtonSVG";
import ForwardButtonSVG from "./ForwardButtonSVG";
import CloseCircleSVG from "./CloseCircleSVG";
import PauseButtonSVG from "./PauseButtonSVG";
import GearWithSchemeAndThreeObjectsSVG from "./GearWithSchemeAndThreeObjectsSVG";
import ComputerWithGraphicsSVG from "./ComputerWithGraphicsSVG";
import VolumeIconWithChipInsideSVG from "./VolumeIconWithChipInsideSVG";
import CloudWithCircleAndPowerIconSVG from "./CloudWithCircleAndPowerIconSVG";
import GearInsidePersonTalkingSVG from "./GearInsidePersonTalkingSVG";
import ComputerWithLight2SVG from "./ComputerWithLight2SVG";
import ComputerWithGraphSVG from "./ComputerWithGraphSVG";
import PersonAndLasersSVG from "./PersonAndLasersSVG";
import PersonWithSunInsideSVG from "./PersonWithSunInsideSVG";
import ChipWithCheckmarkSquareSVG from "./ChipWithCheckmarkSquareSVG";
import PersonInsideMessageBubbleAndHandSVG from "./PersonInsideMessageBubbleAndHandSVG";
import PersonFocusedSVG from "./PersonFocusedSVG";
import BoxWithDiscInsideAndClockSVG from "./BoxWithDiscInsideAndClockSVG";
import PhoneSVG from "./PhoneSVG";
import PersonPhoneSVG from "./PersonPhoneSVG";
import SettingsSVG from "./SettingsSVG";

interface IconProps {
  type: string;
  style?: React.CSSProperties;
  color?: string;
}

const Icon = (props: IconProps) => {
  const { style = {}, color = "black" } = props;

  const iconsSvg: { [key: string]: any } = {
    ai: <AiSVG style={style} color={color} />,
    arrowsDown: <ArrowsDownSVG style={style} color={color} />,
    arrowsDownWithPeople: <ArrowsDownWithPeopleSVG style={style} color={color} />,
    "arrow-left": <ArrowLeftSVG style={style} color={color} />,
    "arrow-right": <ArrowRightSVG style={style} color={color} />,
    arrowsUp: <ArrowsUpSVG style={style} color={color} />,
    arrowsUpWithDollarSign: <ArrowsUpWithDollarSignSVG style={style} color={color} />,
    autonomousManagement: <AutonomousManagementSVG style={style} color={color} />,
    bellWithCheckmark: <BellWithCheckmarkSVG style={style} color={color} />,
    boxAndAdjustableWrench: <BoxAndAdjustableWrenchSVG style={style} color={color} />,
    boxWithCircleInside: <BoxWithCircleInsideSVG style={style} color={color} />,
    boxWithDiscInsideAndClock: <BoxWithDiscInsideAndClockSVG style={style} color={color} />,
    boxWithGear: <BoxWithGearSVG style={style} color={color} />,
    boxWithLock: <BoxWithLockSVG style={style} color={color} />,
    checkmarksConnectedByALine: <CheckmarksConnectedByALineSVG style={style} color={color} />,
    brain: <BrainSVG style={style} color={color} />,
    circle: <CircleSVG style={style} color={color} />,
    circleCheckMark: <CircleCheckMarkSVG style={style} color={color} />,
    circlesConnected: <CirclesConnectedSVG style={style} color={color} />,
    chip: <ChipSVG style={style} color={color} />,
    chipWithCheckmarkSquare: <ChipWithCheckmarkSquareSVG style={style} color={color} />,
    chipWithCheckmark: <ChipWithCheckmarkSVG style={style} color={color} />,
    chipInsideCircleAndWirelessControl: <ChipInsideCircleAndWirelessControlSVG style={style} color={color} />,
    chipInsideCircleArrow: <ChipInsideCircleArrowSVG style={style} color={color} />,
    clock: <ClockSVG style={style} color={color} />,
    clockWithChipInside: <ClockWithChipInsideSVG style={style} color={color} />,
    close: <CloseSVG style={style} color={color} />,
    closeCircle: <CloseCircleSVG style={style} color={color} />,
    cloudLikeSun: <CloudLikeSunSVG style={style} color={color} />,
    cloudWithCircleAndPowerIcon: <CloudWithCircleAndPowerIconSVG style={style} color={color} />,
    cloudWithCircuits: <CloudWithCircuitsSVG style={style} color={color} />,
    cloudWithMachine: <CloudWithMachineSVG style={style} color={color} />,
    cloudWithScheme: <CloudWithSchemeSVG style={style} color={color} />,
    computerFocusingPerson: <ComputerFocusingPersonSVG style={style} color={color} />,
    computerGuyAndAntenna: <ComputerGuyAndAntennaSVG style={style} color={color} />,
    computerMarketplace: <ComputerMarketplaceSVG style={style} color={color} />,
    computerWithAdjustableWrench: <ComputerWithAdjustableWrenchSVG style={style} color={color} />,
    computerWithBoxAndPencils: <ComputerWithBoxAndPencilsSVG style={style} color={color} />,
    computerWithCar: <ComputerWithCarSVG style={style} color={color} />,
    computerWithChecklistBehind: <ComputerWithChecklistBehindSVG style={style} color={color} />,
    computerWithChessPiece: <ComputerWithChessPieceSVG style={style} color={color} />,
    computerWithCloud: <ComputerWithCloudSVG style={style} color={color} />,
    computerWithEyeAndChip: <ComputerWithEyeAndChipSVG style={style} color={color} />,
    computerWithGearAndCircuits: <ComputerWithGearAndCircuitsSVG style={style} color={color} />,
    computerWithGraph: <ComputerWithGraphSVG style={style} color={color} />,
    computerWithGraphics: <ComputerWithGraphicsSVG style={style} color={color} />,
    computerWithLight: <ComputerWithLightSVG style={style} color={color} />,
    computerWithLight2: <ComputerWithLight2SVG style={style} color={color} />,
    computerWithMapAndLittleBox: <ComputerWithMapAndLittleBoxSVG style={style} color={color} />,
    computerWithMeter: <ComputerWithMeterSVG style={style} color={color} />,
    computerWithPaper: <ComputerWithPaperSVG style={style} color={color} />,
    computerWithPersonAndMessageBubble: <ComputerWithPersonAndMessageBubbleSVG style={style} color={color} />,
    computerWithPolice: <ComputerWithPoliceSVG style={style} color={color} />,
    computerWithPopUpOver: <ComputerWithPopUpOverSVG style={style} color={color} />,
    computerWithRocket: <ComputerWithRocketSVG style={style} color={color} />,
    computerWithScheme: <ComputerWithSchemeSVG style={style} color={color} />,
    computerWithSoundBar: <ComputerWithSoundBarSVG style={style} color={color} />,
    customerService: <CustomerServiceSVG style={style} color={color} />,
    cycleInsideCircle: <CycleInsideCirleSVG style={style} color={color} />,
    dartboard: <DartboardSVG style={style} color={color} />,
    diagram: <DiagramSVG style={style} color={color} />,
    dollarSign: <DollarSignSVG style={style} color={color} />,
    eyeFocus: <EyeFocusSVG style={style} color={color} />,
    forwardButton: <ForwardButtonSVG style={style} color={color} />,
    gearInsideCircle: <GearInsideCircleSVG style={style} color={color} />,
    gearInsidePerson: <GearInsidePersonSVG style={style} color={color} />,
    gearInsidePersonTalking: <GearInsidePersonTalkingSVG style={style} color={color} />,
    gearsWithArrows: <GearsWithArrowsSVG style={style} color={color} />,
    gearWithSchemeAndThreeObjects: <GearWithSchemeAndThreeObjectsSVG style={style} color={color} />,
    gearWithCheckmark: <GearWithCheckmarkSVG style={style} color={color} />,
    gearWithCircuits: <GearWithCircuitsSVG style={style} color={color} />,
    gearWithCircuits2: <GearWithCircuits2SVG style={style} color={color} />,
    gearWithSchema: <GearWithSchemaSVG style={style} color={color} />,
    graphArrowUp: <GraphArrowUpSVG style={style} color={color} />,
    graphArrowUpInsideCircle: <GraphArrowUpInsideCircleSVG style={style} color={color} />,
    graphDownArrowWithDollarSign: <GraphDownArrowWithDollarSignSVG style={style} color={color} />,
    graphDownArrowWithDollarSign2: <GraphDownArrowWithDollarSign2SVG style={style} color={color} />,
    graphArrowDownUpDown: <GraphArrowDownUpDownSVG style={style} color={color} />,
    graphWithDollarSign: <GraphWithDollarSignSVG style={style} color={color} />,
    graphWithMagnificationAndGear: <GraphWithMagnificationAndGearSVG style={style} color={color} />,
    graphWithMagnification: <GraphWithMagnificationSVG style={style} color={color} />,
    home: <HomeSVG style={style} color={color} />,
    info: <InfoSVG style={style} color={color} />,
    lifecycle: <LifecycleSVG style={style} color={color} />,
    marketplace: <MarketplaceSVG style={style} color={color} />,
    message: <MessageSVG style={style} color={color} />,
    modularArchitecture: <ModularArchitectureSVG style={style} color={color} />,
    network: <NetworkSVG style={style} color={color} />,
    pauseButton: <PauseButtonSVG style={style} color={color} />,
    peopleAndCheckmark: <PeopleAndCheckmarkSVG style={style} color={color} />,
    peopleConnectedByGear: <PeopleConnectedByGearSVG style={style} color={color} />,
    peopleInsideGear: <PeopleInsideGearSVG style={style} color={color} />,
    peopleWithCheckmarkAndMessageBubble: <PeopleWithCheckmarkAndMessageBubbleSVG style={style} color={color} />,
    peopleWithCircuitsInsideCircle: <PeopleWithCircuitsInsideCircleSVG style={style} color={color} />,
    peopleWithMessageCloud: <PeopleWithMessageCloudSVG style={style} color={color} />,
    personAndLasers: <PersonAndLasersSVG style={style} color={color} />,
    personFocused: <PersonFocusedSVG style={style} color={color} />,
    personFocusedWithCheckmark: <PersonFocusedWithCheckmarkSVG style={style} color={color} />,
    personInsideChip: <PersonInsideChipSVG style={style} color={color} />,
    personInsideMessageBubbleAndHand: <PersonInsideMessageBubbleAndHandSVG style={style} color={color} />,
    personWithLight: <PersonWithLightSVG style={style} color={color} />,
    personWithSunInside: <PersonWithSunInsideSVG style={style} color={color} />,
    phoneWithBoxesConnected: <PhoneWithBoxesConnectedSVG style={style} color={color} />,
    phoneWithHand: <PhoneWithHandSVG style={style} color={color} />,
    play: <PlaySVG style={style} color={color} />,
    playButton: <PlayButtonSVG style={style} color={color} />,
    puzzle: <PuzzleSvg style={style} color={color} />,
    questionBubble: <QuestionBubbleSVG style={style} color={color} />,
    rearAndMachine: <RearAndMachineSVG style={style} color={color} />,
    reel: <ReelSVG style={style} color={color} />,
    rewindButton: <RewindButtonSVG style={style} color={color} />,
    robotAndGear: <RobotAndGearSVG style={style} color={color} />,
    robotWithLittleBox: <RobotWithLittleBoxSVG style={style} color={color} />,
    rocketAndHandWithCoin: <RocketAndHandWithCoinSVG style={style} color={color} />,
    schemeAndBuildingInline: <SchemeAndBuildingInlineSVG style={style} color={color} />,
    schemeWithCheckmarkShield: <SchemeWithCheckmarkShieldSVG style={style} color={color} />,
    schieldWithCheckmark: <SchieldWithCheckmarkSVG style={style} color={color} />,
    screenWithDollarSignAndGear: <ScreenWithDollarSignAndGearSVG style={style} color={color} />,
    truckWithBoxAndComputer: <TruckWithBoxAndComputerSVG style={style} color={color} />,
    volumeIconWithChipInside: <VolumeIconWithChipInsideSVG style={style} color={color} />,
    warningCircle: <WarningCircleSVG style={style} color={color} />,
    workflow: <WorkflowSVG style={style} color={color} />,
    worldAndCheckmark: <WorldAndCheckmarkSVG style={style} color={color} />,
    worldAndSchemeLine: <WorldAndSchemeLineSVG style={style} color={color} />,
    worldWithCircuits: <WorldWithCircuitsSVG style={style} color={color} />,
    worldWithMachine: <WorldWithMachineSVG style={style} color={color} />,
    worldWithRing: <WorldWithRingSVG style={style} color={color} />,
    worldWithScheme: <WorldWithSchemeSVG style={style} color={color} />,
    "deep-dive": <DeepDiveSVG style={style} color={color} />,
    "historical-data": <HistoricalDataSVG style={style} color={color} />,
    "like-finger": <LikeFingerSVG style={style} color={color} />,
    "proactive-communication": <ProactiveCommunicationSVG style={style} color={color} />,
    "cost-reduction": <CostReductionSVG style={style} color={color} />,
    "lead-time-reduction": <LeadTimeReductionSVG style={style} color={color} />,
    "automatic-case": <AutomaticCaseSVG style={style} color={color} />,
    "comprehensive-visibility": <ComprehensiveVisibilitySVG style={style} color={color} />,
    "window-and-comment": <WindowAndCommentSVG style={style} color={color} />,
    filter: <FilterSVG style={style} color={color} />,
    personWithArrows: <PersonWithArrowsSVG style={style} color={color} />,
    ok: <OkSVG style={style} color={color} />,
    "comprehensive-fault-visibility": <ComprehensiveFaultVisibilitySVG style={style} color={color} />,
    service: <ServiceSVG style={style} color={color} />,
    signal5G: <Signal5GSVG style={style} color={color} />,
    phone: <PhoneSVG style={style} color={color} />,
    personPhone: <PersonPhoneSVG style={style} color={color} />,
    settings: <SettingsSVG style={style} color={color} />,
  };

  return iconsSvg[props.type];
};

export default Icon;
